import { createFileRoute, redirect } from "@tanstack/react-router";

import { ProjectSettingsPage } from "@/features/projects/ProjectsPage";

export const Route = createFileRoute("/_app/projects/$projectId")({
  beforeLoad: ({ context }) => {
    if (context.info.edition !== "cloud") throw redirect({ to: "/admin" });
  },
  component: function ProjectSettingsRoute() {
    const { projectId } = Route.useParams();
    return <ProjectSettingsPage key={projectId} projectId={projectId} />;
  },
});
